import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { PHONE_NUMBER, PHONE_TEL } from "../../config/siteConfig";

export const FinalCTA = () => (
  <section className="py-20">
    <div className="mx-auto max-w-7xl px-6">
      <div className="rounded-3xl bg-gradient-to-br from-blue-600/20 via-cyan-600/10 to-transparent border border-blue-500/20 p-10 md:p-16 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Ready to Fight for Your Account?
        </h2>
        <p className="text-slate-300 text-lg max-w-2xl mx-auto mb-8">
          Run our free Suspension Analyzer for a policy-mapped diagnosis in 60 seconds — no payment, no email required. We&rsquo;ll tell you honestly if we can help.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/analyze"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-slate-950 px-8 py-4 text-base font-semibold shadow-xl hover:bg-slate-100 transition"
            data-testid="final-cta-primary"
          >
            <Sparkles className="w-5 h-5" />
            Analyze My Suspension
            <ArrowRight className="w-5 h-5" />
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 px-8 py-4 text-base font-medium hover:bg-white/5 transition"
            data-testid="final-cta-secondary"
          >
            Get a Free Case Assessment
          </Link>
        </div>
        <p className="mt-6 text-sm text-slate-500">
          Or call us directly: <a href={PHONE_TEL} className="text-blue-400 hover:underline">{PHONE_NUMBER}</a>
        </p>
      </div>
    </div>
  </section>
);
